import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { HelmetProvider } from "react-helmet-async";

// Inject the mandala background pattern using PUBLIC_URL so the asset
// resolves correctly from the public folder instead of webpack trying
// to bundle it as a JS/CSS module import.
const mandalaStyle = document.createElement("style");
mandalaStyle.innerHTML = `.bg-mandala { background-image: url("${process.env.PUBLIC_URL}/mandala-bg.svg"); }`;
document.head.appendChild(mandalaStyle);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);
